let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iY2wN")).then(() => parcelRequire('c2JK5'));